import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

import { CronJobExecutionLogRow } from "services/api/cronjobs/types";
import { formatCronDateTime } from "services/api/cronjobs/transformations";

/**
 * Log obrade. Tekst je u monospace fontu s očuvanim prijelomima — obrade pišu i tablice i
 * stack traceove, pa ih ne treba preoblikovati.
 */
export const CRON_JOB_EXECUTION_LOG_COLUMNS: Column[] = [
  {
    title: "#",
    field: "id",
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionLogRow) => (
      <span className="font-mono text-xs text-slate-400">{row.id}</span>
    ),
  },
  {
    title: "Vrijeme",
    field: "created",
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionLogRow) => (
      <div className="whitespace-nowrap">
        <div className="text-sm text-slate-700">{formatCronDateTime(row.created)}</div>
        {row.updated && (
          <div className="text-xs text-slate-400">dopunjeno {formatCronDateTime(row.updated)}</div>
        )}
      </div>
    ),
  },
  {
    title: "Zapis",
    field: "log",
    type: ColumnTypes.custom,
    render: (row: CronJobExecutionLogRow) => (
      <pre className="font-mono text-xs text-slate-800 whitespace-pre-wrap break-words">
        {row.log}
      </pre>
    ),
  },
];
